<div [ngClass]="{'selected': selected }" class="block-container">
	<div class="img-container" (click)="showClipDetails(step?.entityId, step?.description)">
		<img class="thumbnail" [src]="thumbSrc" (error)="loadPlaceholder($event)" />
		<div class="no-thumbnail-placeholder">
			<span class="fa fa-film fa-2x"></span>
		</div>
	</div>

	<div class="content-container">
		<div class="title">
			<h3>{{ step?.description }}</h3>
		</div>
	
		<div class="engagement">
			<div class="engagement_column">
				<span class="fas fa-code"></span>
				<span class="value">{{ stepStats?.stats?.inits | number }}</span>
			</div>
			<div class="engagement_column">
				<span class="fas fa-eye"></span>
				<span class="value">{{ stepStats?.stats?.views | number }}</span>
			</div>
		</div>
	</div>
</div>
